export const generateYearsRange = (startingYear: number): number[] => {
  const currentYear = new Date().getFullYear()
  const years: number[] = Array.from(
    { length: currentYear - startingYear + 1 },
    (_, index) => currentYear - index
  )

  return years
}
